import React, { useEffect, useRef, useState } from 'react';

/**
 * G5-T34.8: Embed SDK demo / test sayfası.
 * embed-sdk.js'i kullanarak DataScope'u iframe içinde yükler.
 */
export function EmbedDemoPage() {
  const containerRef = useRef(null);
  const embedRef = useRef(null);
  const [log, setLog] = useState([]);
  const [theme, setTheme] = useState('light');
  const [path, setPath] = useState('/rules');

  const addLog = (msg) => setLog(prev => [`[${new Date().toLocaleTimeString()}] ${msg}`, ...prev.slice(0, 19)]);

  useEffect(() => {
    if (!window.DataScopeEmbed || !containerRef.current) return;

    embedRef.current = new window.DataScopeEmbed({
      container: containerRef.current,
      src: window.location.origin,
      theme,
      onReady: () => addLog('DS_READY — embed hazır'),
      onNavigate: (p) => addLog(`DS_NAVIGATE → ${p}`),
      onError: (msg) => addLog(`DS_ERROR: ${msg}`),
      onResize: (h) => addLog(`DS_RESIZE: ${h}px`),
    });

    embedRef.current.mount();
    return () => embedRef.current?.destroy();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleNavigate = () => {
    embedRef.current?.navigate(path);
    addLog(`Navigate gönderildi: ${path}`);
  };

  const handleTheme = (t) => {
    setTheme(t);
    embedRef.current?.setTheme(t);
    addLog(`Tema değiştirildi: ${t}`);
  };

  return (
    <div style={{ display: 'flex', gap: 16, padding: 16, height: '100vh', boxSizing: 'border-box' }}>
      {/* Sol panel: kontroller */}
      <div style={{ width: 260, flexShrink: 0 }}>
        <h5>Embed SDK Demo</h5>
        <hr />

        <div className="mb-3">
          <label className="form-label fw-semibold">Navigasyon</label>
          <div className="input-group">
            <input
              className="form-control form-control-sm"
              value={path}
              onChange={e => setPath(e.target.value)}
            />
            <button className="btn btn-sm btn-primary" onClick={handleNavigate}>Git</button>
          </div>
          <div className="mt-1 d-flex gap-1 flex-wrap">
            {['/rules', '/workflows', '/actions'].map(p => (
              <button key={p} className="btn btn-outline-secondary btn-sm" onClick={() => { setPath(p); embedRef.current?.navigate(p); addLog(`Navigate: ${p}`); }}>
                {p}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Tema</label>
          <div className="d-flex gap-2">
            <button className={`btn btn-sm ${theme === 'light' ? 'btn-warning' : 'btn-outline-warning'}`} onClick={() => handleTheme('light')}>Light</button>
            <button className={`btn btn-sm ${theme === 'dark' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => handleTheme('dark')}>Dark</button>
          </div>
        </div>

        <div>
          <label className="form-label fw-semibold">Mesaj Logu</label>
          <div style={{ fontFamily: 'monospace', fontSize: 11, background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 4, padding: 8, height: 300, overflowY: 'auto' }}>
            {log.length === 0 ? <span className="text-muted">Bekleniyor...</span> : log.map((l, i) => <div key={i}>{l}</div>)}
          </div>
          <button className="btn btn-sm btn-outline-secondary mt-1" onClick={() => setLog([])}>Temizle</button>
        </div>
      </div>

      {/* Sağ panel: iframe */}
      <div ref={containerRef} style={{ flex: 1, border: '2px dashed #dee2e6', borderRadius: 8, overflow: 'hidden', background: '#fff' }} />
    </div>
  );
}
